import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/_app/admin/automations/$organizationId/$automationId/',
)({
    beforeLoad: ({ location, params }) => {
        throw redirect({
            to: '/admin/agent/automations/$organizationId/$automationId',
            params,
            search: location.search,
            replace: true,
        });
    },
    component: () => null,
});
